'use client'

import React from 'react'

type Props = {
    radius: number
    height: number
}

const WIDTH = 340
const HEIGHT = 220

export default function CylinderChart({ radius, height }: Props) {
    const maxDim = Math.max(radius * 2, height, 0.0001)
    const scale = 140 / maxDim
    const rx = Math.max(radius * scale, 28)
    const ry = rx * 0.32
    const h = Math.max(height * scale, 30)

    const cx = WIDTH / 2
    const topY = (HEIGHT - h) / 2 - 10
    const bottomY = topY + h

    return (
        <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} style={{ maxWidth: '100%', height: 'auto' }}>
            {/* body */}
            <rect x={cx - rx} y={topY} width={rx * 2} height={h} fill="#2563eb" opacity={0.18} stroke="none" />
            <line x1={cx - rx} y1={topY} x2={cx - rx} y2={bottomY} stroke="#2563eb" strokeWidth={2} />
            <line x1={cx + rx} y1={topY} x2={cx + rx} y2={bottomY} stroke="#2563eb" strokeWidth={2} />
            {/* bottom ellipse */}
            <ellipse cx={cx} cy={bottomY} rx={rx} ry={ry} fill="#2563eb" opacity={0.22} stroke="#2563eb" strokeWidth={2} />
            {/* top ellipse */}
            <ellipse cx={cx} cy={topY} rx={rx} ry={ry} fill="#eff6ff" stroke="#2563eb" strokeWidth={2} />
            {/* radius marker on top */}
            <line x1={cx} y1={topY} x2={cx + rx} y2={topY} stroke="#dc2626" strokeWidth={1.5} />
            <text x={cx + rx / 2} y={topY - 6} fontSize={11} textAnchor="middle" fill="#dc2626">r = {radius.toFixed(2)}</text>
            {/* height marker */}
            <line x1={cx - rx - 16} y1={topY} x2={cx - rx - 16} y2={bottomY} stroke="#16a34a" strokeWidth={1.5} />
            <text x={cx - rx - 22} y={(topY + bottomY) / 2} fontSize={11} textAnchor="end" fill="#16a34a">h = {height.toFixed(2)}</text>
        </svg>
    )
}
